import React from 'react';
import TableView from './TableView';

const TermsOfServicePage = () => {
	return <TableView />;
};

export default TermsOfServicePage;
